<template>
  <v-container fluid class="bankaccount-add-page mt-3 mx-1">
    <v-row>
      <v-col cols="12">
        <v-stepper v-model="step" class="transparent elevation-0">
          <v-card class="mb-5">
            <v-stepper-header >
              <v-stepper-step :complete="step > 1" step="1">Bank Account</v-stepper-step>
            </v-stepper-header>
          </v-card>

          <v-card>
            <v-stepper-items>
              <v-stepper-content step="1">
                <v-card>
                  <v-row justify="center">
                    <v-col cols="12" md="6"><p class="text-h5">New Bank Account</p></v-col>
                  </v-row>
                  <v-row justify="center">
                    <v-col cols="12" md="3">
                      <v-form>
                        <v-text-field
                          class="mb-4"
                          v-model="bankaccount.accountcode"
                          v-bind:error="errorindex == 0"
                          outlined
                          dense
                          placeholder="Bank Account Code"
                          persistent-hint
                          single-line hint="Enter the account code">
                        </v-text-field>
                        <v-text-field
                          class="mb-4"
                          v-model="bankaccount.accountname"
                          v-bind:error="errorindex == 1"
                          outlined
                          dense
                          placeholder="Bank Account Name"
                          persistent-hint
                          single-line hint="Enter the account name">
                        </v-text-field>
                        <v-select
                          class="mb-4"
                          :items=account_types
                          v-model="bankaccount.accounttype"
                          v-bind:error="errorindex == 2"
                          outlined
                          dense
                          placeholder="Type"
                          persistent-hint
                          single-line hint="Please choose account type">
                        </v-select>
                      </v-form>
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-form>
                        <v-select
                          class="mb-4"
                          :items="[
                            {text: 'None', value: null},
                            ...accounts.filter(account=>account.accountsubclass=='Bank').map(x => {return {text: x.accountname, value: x._id}})
                          ]"
                          v-model="bankaccount.accountid"
                          outlined
                          dense
                          placeholder="Account"
                          persistent-hint
                          single-line hint="Please choose the account">
                        </v-select>
                        <v-menu
                          ref="menu_accountstartdate"
                          v-model="menu_accountstartdate"
                          :close-on-content-click="false"
                          :return-value.sync="bankaccount.accountstartdate"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              outlined
                              dense
                              v-model="bankaccount.accountstartdate"
                              label="Opening Date"
                              v-bind="attrs"
                              v-bind:value="bankaccount.accountstartdate"
                              v-bind:error="errorindex == 4"
                              v-on="on"
                              persistent-hint
                              single-line hint="Please account opening date">
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="bankaccount.accountstartdate"
                            no-title
                            scrollable
                          >
                            <v-spacer></v-spacer>
                            <v-btn
                              text
                              color="primary"
                              @click="menu_accountstartdate = false"
                            >
                              Cancel
                            </v-btn>
                            <v-btn
                              text
                              color="primary"
                              @click="$refs.menu_accountstartdate.save(bankaccount.accountstartdate)"
                            >
                              OK
                            </v-btn>
                          </v-date-picker>
                        </v-menu>
                        <v-menu
                          ref="menu_accountenddate"
                          v-model="menu_accountenddate"
                          :close-on-content-click="false"
                          :return-value.sync="bankaccount.accountenddate"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              outlined
                              dense
                              v-model="bankaccount.accountenddate"
                              label="Closing Date"
                              v-bind="attrs"
                              v-bind:value="bankaccount.accountenddate"
                              v-bind:error="errorindex == 5"
                              v-on="on"
                              persistent-hint
                              single-line hint="Please account closing date">
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="bankaccount.accountenddate"
                            no-title
                            scrollable
                          >
                            <v-spacer></v-spacer>
                            <v-btn
                              text
                              color="primary"
                              @click="menu_accountenddate = false"
                            >
                              Cancel
                            </v-btn>
                            <v-btn
                              text
                              color="primary"
                              @click="$refs.menu_accountenddate.save(bankaccount.accountenddate)"
                            >
                              OK
                            </v-btn>
                          </v-date-picker>
                        </v-menu>
                      </v-form>
                    </v-col>
                  </v-row>
                        <v-row justify="center">
                          <v-col cols="12" md="6">
                            <div class="d-flex justify-center">
                              <v-btn
                                  to="/bankaccount/list"
                                  replace
                                  outlined
                                  color="primary"
                              >
                                Cancel
                              </v-btn>
                              <v-spacer></v-spacer>
                                <v-btn
                                  :loading="isReceiving"
                                  class="button-shadow"
                                  color="primary"
                                  @click="insertBankAccount()">
                                  Save
                                </v-btn>
                            </div>
                          </v-col>
                        </v-row>
                </v-card>
              </v-stepper-content>
            </v-stepper-items>
          </v-card>

        </v-stepper>
      </v-col>
    </v-row>
  </v-container>

</template>

<script>
import {mapActions, mapState} from "vuex";
import router from '@/Routes';

export default {
  data () {
    return {
      step: 1,
      bankaccount: {},
      account_types: ['Bank Account', 'Credit Card', 'Digital Wallet', 'Other Bank Account'],
      menu_accountstartdate: null,
      menu_accountenddate: null,
      error: undefined,
      haserror: false,
      errorindex: undefined,
    }
  },

  methods: {
    ...mapActions('BankAccount', ['insertBankAccountRequest', 'getBankAccountsRequest']),
    ...mapActions('Account', ['getAccountsRequest']),
    checkError(){
      if(!this.bankaccount.accountcode){
        this.haserrors = true;
        this.errorindex = 0;
        return false;
      }
      if(!this.bankaccount.accountname){
        this.haserrors = true;
        this.errorindex = 1;
        return false;
      }
      if(!this.bankaccount.accounttype){
        this.haserrors = true;
        this.errorindex = 2;
        return false;
      }
      this.errorindex = -1;
      return true;
    },
    async insertBankAccount() {
      if(!this.checkError()) return;
      console.log(this.bankaccount)
      await this.insertBankAccountRequest(this.bankaccount);
      this.getBankAccountsRequest();
      router.push('/bankaccount/list');
    },
  },
  computed: {
    ...mapState('BankAccount', ['isReceiving']),
    ...mapState('Account', ['accounts'])
  },
  async created(){
    if(this.accounts.length==0) await this.getAccountsRequest();
  }

}
</script>

<style src="./Add.scss" lang="scss"></style>
